import { api } from "../api";

/**
 * helpTicketFindAllExportResponse - Function that finds on database all tickets by status and then exports in a PDF/XSLX file  
 * /departments/{departmentId}/tickets/{status}/{exportType}/export 
 * method GET  
 * @async-function
 */
const helpTicketFindAllExportResponse = async (token: string, status: string, exportType: string, customerId: number,  departmentId?: number, ignoreDepartments: Boolean = false, simpleXlsxExport = false) => {
    const path = ((departmentId && departmentId > 0) || ignoreDepartments == true) ?
      `departments/-1/${departmentId}/${customerId}/tickets/${status}/${exportType}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}` :
      `/tickets/${customerId}/${status}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`;
      
    const response = await api.get(
        path, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default helpTicketFindAllExportResponse;

